import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * Lightweight OAuth callback component for RingCentral per-number auth.
 * Opens in a popup, reads code+state from URL, posts to parent window, closes itself.
 */
@Component({
  selector: 'app-rc-oauth-callback',
  standalone: true,
  template: `
    <div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;">
      <div style="text-align:center;">
        <p style="font-size:16px;">Connecting to RingCentral...</p>
        <p style="font-size:13px;color:#666;">This window will close automatically.</p>
      </div>
    </div>
  `,
})
export class RcOauthCallbackComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const state = params['state'];

      if (code && state && window.opener) {
        window.opener.postMessage(
          { type: 'rc-oauth-callback', code, state },
          window.location.origin,
        );
        setTimeout(() => window.close(), 1000);
      }
    });
  }
}
